const config =
  process.env.NODE_ENV === "development"
    ? window.LocalConfig
    : window.ReleaseConfig;

export default config;
